module.exports = __webpack_public_path__ + "static/media/cryoboost.5ba51e5f.png";